const ROLES = [
    { label: 'Employee', value: 'Employee' },
    { label: 'Manager', value: 'Manager' },
    { label: 'Admin', value: 'Admin' },
]

export default ROLES
